import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { MapPin, ArrowLeft } from "lucide-react";
import { Lightbox } from "../components/Lightbox";
import { StoryActions } from "../components/StoryActions";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function StoryDetail() {
  const { id } = useParams();
  const [story, setStory] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [lb, setLb] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API}/tori/${id}`)
      .then((r) => setStory(r.data))
      .catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="max-w-[800px] mx-auto w-full px-6 py-20 text-center">
        <p className="font-[600] text-[#0D3B4C]">Verhaal niet gevonden.</p>
        <Link to="/verhalen" className="inline-block mt-6 bg-[#B71C1C] text-white font-[700] uppercase py-3 px-8 rounded-full">
          Terug naar verhalen
        </Link>
      </div>
    );
  }
  if (!story) {
    return <div className="max-w-[800px] mx-auto w-full px-6 py-20 text-center font-[600] text-[#0D3B4C]">Laden...</div>;
  }

  const photos = story.photos || [];
  const place = story.locality || story.location_text;
  const nav = (d) => setLb((prev) => prev && ({ ...prev, index: (prev.index + d + photos.length) % photos.length }));

  return (
    <div className="max-w-[900px] mx-auto w-full px-6 py-12" data-testid="story-detail">
      <Link to="/verhalen" data-testid="back-to-stories" className="inline-flex items-center gap-2 font-[600] text-[#1B6B2E] hover:text-[#144F22] transition-colors">
        <ArrowLeft size={18} /> Alle verhalen
      </Link>

      <h1 className="text-4xl sm:text-5xl font-[700] text-[#0D3B4C] tracking-tight mt-6">{story.name}</h1>
      {place && (
        <p className="mt-2 font-[600] text-[#1B6B2E] flex items-center gap-1">
          <MapPin size={16} /> {place}
        </p>
      )}

      {photos.length > 0 && (
        <div className={`grid gap-2 mt-6 ${photos.length === 1 ? "grid-cols-1" : "grid-cols-2 md:grid-cols-3"}`}>
          {photos.map((p, i) => (
            <button
              key={p}
              onClick={() => setLb({ photos, index: i })}
              data-testid={`detail-photo-${i}`}
              className="aspect-square overflow-hidden bg-[#E8F5E9]"
            >
              <img
                src={`${BACKEND}${p}`}
                alt=""
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                onError={(e) => { e.currentTarget.parentElement.style.display = "none"; }}
              />
            </button>
          ))}
        </div>
      )}

      <p className="text-lg font-[400] text-[#0D3B4C] leading-relaxed mt-8 whitespace-pre-line">{story.story}</p>

      <div className="mt-10 pt-6 border-t-2 border-[#E8F5E9]">
        <StoryActions id={story.id} likes={story.likes} size="lg" />
      </div>

      {lb && <Lightbox photos={lb.photos} index={lb.index} onClose={() => setLb(null)} onNav={nav} />}
    </div>
  );
}
